import BurgerNavigation from './BurgerNavigation';

export default BurgerNavigation;
